import type { CatalogSuggestion } from "@/types";

/** Shared max length for support ticket / chat-style composers. */
export const MAX_COMPOSER_MESSAGE_LENGTH = 5000;

export const COMPOSER_LENGTH_WARNING_THRESHOLD = Math.floor(
	MAX_COMPOSER_MESSAGE_LENGTH * 0.95,
);

export function shouldShowComposerLengthCounter(length: number) {
	return length >= COMPOSER_LENGTH_WARNING_THRESHOLD;
}

/** Shared typography for new support ticket form field values and placeholders. */
export const supportTicketFormFieldTextClassName =
	"text-xs placeholder:text-xs text-foreground";

export function buildSupportTicketMessageDescription(
	message: string,
	catalogSuggestions: CatalogSuggestion[],
) {
	const trimmed = message.trim();
	if (!catalogSuggestions.length) return trimmed;

	const catalogLines = catalogSuggestions
		.map((item) => `- ${item.title}: ${item.url}`)
		.join("\n");

	if (!trimmed) {
		return `Service catalog\n\nRelated services:\n${catalogLines}`;
	}

	return `${trimmed}\n\nRelated services:\n${catalogLines}`;
}

export function hasSupportTicketMessageContent(
	message: string,
	fileCount: number,
	catalogCount: number,
) {
	return (
		Boolean(message.trim()) ||
		fileCount > 0 ||
		catalogCount > 0
	);
}
